import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {selectVirtualEventActivity} from '../../../features/activity/activity.selectors';
import {I18nPluralPipe} from '@angular/common';
import {Observable} from 'rxjs';
import {selectAuctioneerLayoutHeight} from '../../../../core/features/layout.selectors';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-recent-activities',
  templateUrl: './recent-activities.component.html',
  styleUrls: ['./recent-activities.component.scss'],
  providers: [I18nPluralPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentActivitiesComponent {
  public activities$: Observable<any> = this.store.pipe(select(selectVirtualEventActivity));
  public height$: any = this.store.pipe(
    select(selectAuctioneerLayoutHeight),
    map(height => {
      //const size = 100*(height/window.innerHeight);
      //return size < 9.39 ? 9.39: size;
      // return 9.39*5;
      return window.innerHeight - 200;
    })
  );

  @Input() type: any = 'dark';

  constructor(
    private store: Store<any>
  ) {}
}
